module.exports = __webpack_public_path__ + "img/aiimg4.32ec3edb.png";